import api from "@/config/api";
import type { RequestOptions } from "@/shared/types/api.types";
import { API_ENDPOINTS } from "@/constants/api-endpoints";
import type { PageResponseDTO } from "@/shared/types/pagination.types";
import type {
  GraduationRequestDTO,
  GraduationResponseDTO,
  GraduationSearchParams,
} from "../types/graduation.types";

export const graduationService = {
  search: async (
    params?: GraduationSearchParams,
    options?: RequestOptions,
  ): Promise<PageResponseDTO<GraduationResponseDTO>> => {
    const response = await api.get<PageResponseDTO<GraduationResponseDTO>>(
      API_ENDPOINTS.GRADUATIONS_ADMIN.SEARCH,
      { params, signal: options?.signal },
    );
    return response.data;
  },

  getById: async (
    id: number,
    options?: RequestOptions,
  ): Promise<GraduationResponseDTO> => {
    const response = await api.get<GraduationResponseDTO>(
      API_ENDPOINTS.GRADUATIONS_ADMIN.BY_ID(id),
      { signal: options?.signal },
    );
    return response.data;
  },

  create: async (
    data: GraduationRequestDTO,
  ): Promise<GraduationResponseDTO> => {
    const response = await api.post<GraduationResponseDTO>(
      API_ENDPOINTS.GRADUATIONS_ADMIN.BASE,
      data,
    );
    return response.data;
  },

  update: async (
    id: number,
    data: GraduationRequestDTO,
  ): Promise<GraduationResponseDTO> => {
    const response = await api.put<GraduationResponseDTO>(
      API_ENDPOINTS.GRADUATIONS_ADMIN.BY_ID(id),
      data,
    );
    return response.data;
  },

  remove: async (id: number): Promise<void> => {
    await api.delete(API_ENDPOINTS.GRADUATIONS_ADMIN.BY_ID(id));
  },

  cancel: async (id: number): Promise<GraduationResponseDTO> => {
    const response = await api.post<GraduationResponseDTO>(
      API_ENDPOINTS.GRADUATIONS_ADMIN.CANCEL(id),
    );
    return response.data;
  },
};
